<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">名称</span>
        <el-input v-model="parameter.name" />
      </div>
      <div class="item">
        <span class="item_title">别名</span>
        <el-input v-model="parameter.alias" />
      </div>
      <div class="item">
        <span class="item_title" style="margin-right:10px">素材id</span>
        <el-input v-model="parameter.material_id" />
      </div>
      <div class="item">
        <span class="item_title" style="margin-right:10px">广告主</span>
        <el-input v-model="parameter.account_id" />
      </div>
      <div class="item">
        <span class="item_title">汇总类型</span>
        <el-select
          v-model="parameter.summary_type"
          placeholder="请选择"
          clearable
        >
          <el-option
            v-for="item in [{label:'id',value:'1'},{label:'名称',value:'2'},{label:'别名',value:'3'}]"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <!-- <el-button style="height:37px" type="primary" icon="el-icon-bottom" @click="reportExport">导出报表</el-button> -->
    </div>
    <div class="content1">
      <div>
        合计
      </div>
      <div>
        <div>消耗：</div>
        <div>{{ tableData.total_data && tableData.total_data.total_consume ? tableData.total_data.total_consume : 0 }}</div>
      </div>
    </div>
    <div>
      <el-table
        ref="tableRef"
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        style="width: 100%"
        border
        @sort-change="sortChange"
      >
        <el-table-column
          prop="material_id"
          label="素材id"
        />
        <el-table-column
          prop="name"
          label="素材名称"
        />
        <el-table-column
          prop="alias"
          label="别名"
        />
        <el-table-column
          prop="video_smart_cover"
          label="预览图"
          align="center"
          width="150"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 100px; height: 100px"
              :src="scope.row.video_smart_cover?scope.row.video_smart_cover:'https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png'"
              :preview-src-list="[scope.row.video_smart_cover]"
              @click.stop="handleClickStop"
            />
          </template>
        </el-table-column>
        <el-table-column
          prop="account_id"
          label="广告主"
        />
        <el-table-column
          prop="cost"
          label="成本"
          sortable
        />
        <!-- <el-table-column
          prop="effective_cost"
          label="有效消耗"
        /> -->
        <!-- <el-table-column
          prop="ctr"
          label="点击率"
        />
        <el-table-column
          prop="conversion_rate"
          label="转化率"
        />
        <el-table-column
          prop="conversion_cost"
          label="平均转化成本"
        /> -->
      </el-table>
      <pagination-right
        :total="tableData.count"
        @size-change="fetchPageSize"
        @current-change="fetchCurrentPage"
      />
    </div>
  </div>
</template>

<script>
import { listMaterial_bind_groups, material_details, export_report, set_cost } from '@/api/enormousAmountMaterialReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
// import ExpandClose from '@/components/ExpandClose/index.vue'
export default {
  components: {
    PaginationRight
    // ExpandClose
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        pageSize: 10,
        name: null,
        material_id: null,
        account_id: null,
        summary_type: '2'
      },
      group_name: null,
      date: [this.getNowFormatDate(window.Date.now()), this.getNowFormatDate(window.Date.now())],
      activeItem: null,
      activeText: null,
      order_by: {} // 表格数据排序
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    handleClickStop() {
      this.$nextTick(() => {
        const domImageView = document.querySelector('.el-image-viewer__mask') // 获取遮罩层dom
        if (!domImageView) {
          return
        }
        domImageView.addEventListener('click', () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector('.el-image-viewer__close').click()
        })
      })
    },
    // 获取数据列表
    async getDataList() {
      this.loading = true
      // // value为ture,从搜索按钮点击进入方法，清空排序
      // value && this.sortOrderChang()
      const data = await material_details({ ...this.parameter,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by: this.order_by && this.order_by.field && this.order_by.order ? this.order_by : null
      })
      this.tableData = data.data
      this.loading = false
    },
    // 投放组选搜索
    async querySearchAsync(queryString, cb) {
      const data = await listMaterial_bind_groups({
        name: queryString || null
      })
      cb(data.data.list.map((item) => {
        return {
          value: item.group_name,
          address: item.id
        }
      }))
    },
    // 选中哪一项
    handleSelect(item) {
      this.group_name = item.value
      this.parameter.group_id = item.address
    },
    // 分页
    fetchPageSize(s) {
      this.parameter.pageSize = s
      this.getDataList()
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.getDataList()
    },
    // 清空排序
    // sortOrderChang() {
    //   this.order_by = {}
    //   this.$refs.tableRef.clearSort()
    // },
    // 列表排序
    sortChange(cell) {
      console.log('cell:', cell)
      this.order_by['order'] = !cell.order ? cell.order : cell.order === 'ascending' ? 'asc' : 'desc'
      this.order_by['field'] = !cell.order ? cell.order : 'cost'
      this.getDataList()
    },
    // 重置
    reset() {
      this.parameter = {
        page: 1,
        pageSize: 10,
        name: null,
        material_id: null,
        account_id: null,
        summary_type: '1'
      }
      this.group_name = null
      this.date = []
      this.order_by = {}
      this.$refs.tableRef.clearSort()
      this.getDataList()
    },
    async blur1() {
      if (this.activeItem.consume !== this.activeText) {
        try {
          await set_cost({ id: this.activeItem.id, cost: this.activeText })
          this.$message({
            message: '修改消耗成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },
    searchclick() {
      this.parameter.page = 1
      this.getDataList()
    },
    // 导出报表
    async reportExport() {
      await export_report({ ...this.parameter,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
    },
    getNowFormatDate(timeStamp) {
      var date = new Date(timeStamp)
      var seperator1 = '-'
      var year = date.getFullYear()
      var month = date.getMonth() + 1
      var strDate = date.getDate()
      if (month >= 1 && month <= 9) {
        month = '0' + month
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = '0' + strDate
      }
      var currentdate = year + seperator1 + month + seperator1 + strDate
      return currentdate
    }

  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.square-avatar {
  border-radius: 0; /* 设置边框为直角 */
}

.square-image {
  width: 50px; /* 设置图片宽度和高度相等 */
  height: 50px;
  object-fit: cover; /* 调整图片填充方式，保持比例并裁剪 */
}
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 55px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  // align-items: flex-end;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
      width: 60px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}
.content1{
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.content1>div:nth-child(1){
  margin-right: 7rem;
}
.content1>div{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}
.content1>div>div:nth-child(2){
  color: rgb(138, 37, 37);
}
</style>

